import React from 'react';
import PropTypes from 'prop-types';
import Step from './Step';

const Steps = ({
  steps,
  ...rest
}) => {
  return (
    <React.Fragment>
      {steps.map((step, i) => <Step {...rest} step={step} key={i} />)}
    </React.Fragment>
  );
};

Steps.propTypes = {
  steps: PropTypes.array.isRequired,
};

export default Steps;



// WEBPACK FOOTER //
// ./src/components/landing/pages/main/Steps.js